// extracted by mini-css-extract-plugin
export default {"emptyPage":"Empty_emptyPage__CscJV","title":"Empty_title__IwL33","description":"Empty_description__6Ur-u","link":"Empty_link__UbWJp","shoppingCart":"Empty_shoppingCart__5AprX"};